module.exports = __webpack_public_path__ + "static/media/GoBe-head.1a747b89.svg";